import { Grid, Typography } from "@mui/material";
import Story from "@/components/social/base/Story.tsx";

const Stories = ({ stories, classes }) => (
  <Grid container spacing={2}>
    <Typography variant="h6">Social Media Products</Typography>
    {stories.map((story, index) => (
      <Grid key={index} item xs={12}>
        <Story data={story} classes={classes} />
      </Grid>
    ))}
  </Grid>
);

export default Stories;
